import React, { useEffect } from "react";
import PropTypes from "prop-types";

function NavigationBlocker({ when, message }) {
  useEffect(() => {
    if (!when) return;

    const handleBeforeUnload = e => {
      e.preventDefault();
      e.returnValue = message;
      return message;
    };

    window.addEventListener("beforeunload", handleBeforeUnload);
    return () => window.removeEventListener("beforeunload", handleBeforeUnload);
  }, [when, message]);

  return null;
}

const FormWrapper = props => (
  <React.Fragment>
    <NavigationBlocker when={props.isDirty} message={props.changeLossMessage} />
    {props.children}
  </React.Fragment>
);

FormWrapper.propTypes = {
  isDirty: PropTypes.bool.isRequired,
  changeLossMessage: PropTypes.string.isRequired
};

FormWrapper.defaultProps = {
  isDirty: false,
  changeLossMessage: "You have unsaved changes. Are you sure you want to leave?"
};

export default FormWrapper;
